import React, { useState, useEffect } from "react";
import { getFunnel } from "../api/services";
import { Card, Loading } from "../components/common/UI";
import ProductFunnels from "../components/charts/ProductFunnels";
import MetrikaDetail from "../components/common/MetrikaDetail";
import EcoCrosspromo from "../components/common/EcoCrosspromo";
import styles from "./pages.module.css";

// Заголовок карточки воронки: «Сводно» / «Июль» / «Июль · Неделя 2».
function funnelTitle(months, weeksByMonth, selMonth, period) {
  if (!selMonth) return months.find((m) => m.key === period)?.label || "";
  const monthLabel = months.find((m) => m.key === selMonth)?.label || "";
  if (period === selMonth) return monthLabel;
  const wk = (weeksByMonth[selMonth] || []).find((w) => w.key === period);
  return wk ? `${monthLabel} · ${wk.label}` : monthLabel;
}

export default function Funnel() {
  const [period, setPeriod] = useState("all");
  // Выбранный месяц (для показа второй строки недель). null — «Сводно».
  const [selMonth, setSelMonth] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    getFunnel(period).then((d) => {
      if (!active) return;
      setData(d);
      setLoading(false);
    });
    const reload = () => getFunnel(period).then((d) => setData(d));
    window.addEventListener("ingest-done", reload);
    return () => { active = false; window.removeEventListener("ingest-done", reload); };
  }, [period]);

  const months = data?.months || [];
  const weeksByMonth = data?.weeks_by_month || {};
  // Недели показываем, только когда выбран месяц, у которого они есть.
  const weekTabs = selMonth ? weeksByMonth[selMonth] : null;

  // Клик по месяцу: период = месяц, запоминаем месяц для второй строки.
  const pickMonth = (key) => {
    setPeriod(key);
    setSelMonth(key === "all" ? null : key);
  };
  // Клик по неделе: 'month' → весь месяц, иначе конкретная неделя.
  const pickWeek = (key) => setPeriod(key === "month" ? selMonth : key);

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Воронка продаж</h1>
          <div className={styles.pageSub}>
            Общий рекламный канал TikTok и три продуктовые воронки: переходы, регистрации, активные.
          </div>
        </div>
      </div>

      {months.length > 0 && (
        <div className={styles.tabs} style={{ alignSelf: "flex-start", flexWrap: "wrap" }}>
          {months.map((m) => {
            // Месяц активен, если выбран он сам или одна из его недель.
            const monthActive =
              m.key === "all" ? period === "all" : selMonth === m.key;
            return (
              <button
                key={m.key}
                className={`${styles.tab} ${monthActive ? styles.tabActive : ""}`}
                onClick={() => pickMonth(m.key)}
              >
                {m.label}
              </button>
            );
          })}
        </div>
      )}

      {weekTabs && (
        <div
          className={styles.tabs}
          style={{ alignSelf: "flex-start", flexWrap: "wrap", marginTop: -6 }}
        >
          {weekTabs.map((w) => {
            const weekActive =
              w.key === "month" ? period === selMonth : period === w.key;
            return (
              <button
                key={w.key}
                className={`${styles.tab} ${weekActive ? styles.tabActive : ""}`}
                style={{ fontSize: 12.5, padding: "5px 12px" }}
                onClick={() => pickWeek(w.key)}
              >
                {w.label}
              </button>
            );
          })}
        </div>
      )}

      <Card title={`Воронка — ${funnelTitle(months, weeksByMonth, selMonth, period)}`}>
        {loading || !data ? <Loading /> : <ProductFunnels tiktok={data.tiktok} products={data.products} />}
      </Card>

      <Card title="Переходы на сайты — данные Яндекс.Метрики">
        {loading || !data ? <Loading /> : <MetrikaDetail detail={data.metrika_detail} />}
      </Card>

      <EcoCrosspromo />

      <Card title="Как читать">
        <div style={{ color: "var(--text-dim)", fontSize: 13.5, lineHeight: 1.7 }}>
          Сверху — общий рекламный канал: <b style={{ color: "var(--text)" }}>TikTok</b>, просмотры
          видео @minecraftia_school (собираются автоматически 3 раза в день). Ниже — три воронки по
          продуктам, каждая ступень — реальное действие:<br />
          <b style={{ color: "var(--text)" }}>Переходы</b> — визиты на сайт продукта (Яндекс.Метрика).{" "}
          <b style={{ color: "var(--text)" }}>Регистрации</b> — новые аккаунты, привязанные к продукту
          (по источнику регистрации; у Маськи — появление аккаунта в приложении).{" "}
          <b style={{ color: "var(--text)" }}>Активные</b> — играли (Рублокс), решали задачи
          (Майнкрафтия), общались (Маська).{" "}
          <b style={{ color: "var(--text)" }}>Оплатили</b> — реально платившие: онлайн-оплаты
          Майнкрафтии, покупки звёзд в Маське (у Рублокса платежей пока нет).<br />
          Скобка справа — конверсия между соседними ступенями. Она может быть больше 100%:
          на ступени есть и пользователи, пришедшие раньше этого периода (например, старые игроки
          заходят без новой регистрации).
        </div>
      </Card>
    </div>
  );
}
